'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LangSelect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  font-size: 0.8em;\n  font-weight: 400;\n  padding-right: 1.5em;\n  cursor: pointer;\n  &:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-4px);\n    height: 0;\n    width: 0;\n    border: 7px solid transparent;\n    border-top: 8px solid ', ';\n  }\n'], ['\n  position: relative;\n  font-size: 0.8em;\n  font-weight: 400;\n  padding-right: 1.5em;\n  cursor: pointer;\n  &:after {\n    content: "";\n    display: inline-block;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-4px);\n    height: 0;\n    width: 0;\n    border: 7px solid transparent;\n    border-top: 8px solid ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  list-style: none;\n  padding: 0;\n  position: absolute;\n  font-size: 0.9em;\n  font-weight: 400;\n  top: calc(100% + 10px);\n  margin-left: -0.3em;\n  left: -0.5em;\n  color: black;\n  background-color: white;\n  box-shadow: 0 1px 3px 0 rgba(0,0,0,.2),\n              0 1px 1px 0 rgba(0,0,0,.14),\n              0 2px 1px -1px rgba(0,0,0,.12);\n  transition: all .2s ease-in-out;\n  & li {\n    font-size: 0.9em;\n    width: 5.5em;\n    padding: 0.4em 0.8em;\n    border-bottom: 1px solid ', ';\n    &:last-child {\n      border-bottom: none;\n    }\n    &.active{\n      color: ', ';\n    }\n    & span {\n      margin-right: 5px;\n    }\n  }\n  display: none;\n  &.open {\n    display: block;\n  }\n'], ['\n  list-style: none;\n  padding: 0;\n  position: absolute;\n  font-size: 0.9em;\n  font-weight: 400;\n  top: calc(100% + 10px);\n  margin-left: -0.3em;\n  left: -0.5em;\n  color: black;\n  background-color: white;\n  box-shadow: 0 1px 3px 0 rgba(0,0,0,.2),\n              0 1px 1px 0 rgba(0,0,0,.14),\n              0 2px 1px -1px rgba(0,0,0,.12);\n  transition: all .2s ease-in-out;\n  & li {\n    font-size: 0.9em;\n    width: 5.5em;\n    padding: 0.4em 0.8em;\n    border-bottom: 1px solid ', ';\n    &:last-child {\n      border-bottom: none;\n    }\n    &.active{\n      color: ', ';\n    }\n    & span {\n      margin-right: 5px;\n    }\n  }\n  display: none;\n  &.open {\n    display: block;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline;\n'], ['\n  position: relative;\n  display: inline;\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactFlagIconCss = require('react-flag-icon-css');

var _reactFlagIconCss2 = _interopRequireDefault(_reactFlagIconCss);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */
/*:: import type {FlagIconCodeType} from 'react-flag-icon-css/lib/types/flow/enums.js.flow' */


var FlagIcon = (0, _reactFlagIconCss2.default)(React, { useCssModules: false });

var SelectedLocale = _styledComponents2.default.span(_templateObject, _styles.styles.colors.darkfg);
SelectedLocale.displayName = 'SelectedLocale';
/*::
type LocaleOptionsType = {[string]: {name: string, flag: FlagIconCodeType}}
type LocaleListProps = {
  className?: string,
  selected: string,
  onLanguage: string => void,
  locales: LocaleOptionsType,
}
*/
var LocaleList = (0, _styledComponents2.default)(function (_ref /*: LocaleListProps */) {
  var className = _ref.className,
      locales = _ref.locales,
      selected = _ref.selected,
      onLanguage = _ref.onLanguage;
  return React.createElement(
    'ul',
    { className: className },
    locales && Object.entries(locales).map(function (_ref2 /*: any */) {
      var _ref3 = _slicedToArray(_ref2, 2),
          code = _ref3[0],
          _ref3$ = _ref3[1],
          name = _ref3$.name,
          flag = _ref3$.flag;

      return React.createElement(
        'li',
        { className: selected === code ? 'active' : '', key: code },
        React.createElement(
          'a',
          { onClick: function onClick() {
              return onLanguage(code);
            } },
          React.createElement(FlagIcon, { code: flag }),
          name
        )
      );
    })
  );
})(_templateObject2, _styles.styles.colors.lightborder, _styles.styles.colors.title_decoration);
LocaleList.displayName = 'LocaleList';

/*::
type LangSelectProps = {|
  className?: string,
  onLanguage: (string => void),
  selected: string,
  locales: LocaleOptionsType,
  store: any,
|}
type LangSelectState = {|
  open: bool,
|}
*/
var LangSelect = exports.LangSelect = (0, _styledComponents2.default)(function (_React$Component) {
  _inherits(_class2, _React$Component);

  function _class2() {
    _classCallCheck(this, _class2);

    var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

    _this.toggleOpen = function () {
      _this.setState({
        open: !_this.state.open
      });
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(_class2, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          onLanguage = _props.onLanguage,
          selected = _props.selected,
          locales = _props.locales;


      var selectLanguage = function selectLanguage(lang) {
        _this2.toggleOpen();
        onLanguage(lang);
      };

      var selectedLocale = selected.toUpperCase().split('-')[0];

      return React.createElement(
        'div',
        { className: className },
        React.createElement(
          SelectedLocale,
          { onClick: this.toggleOpen },
          React.createElement(FlagIcon, { code: locales[selectedLocale.toLowerCase()].flag })
        ),
        React.createElement(LocaleList, { className: '' + (this.state.open ? 'open' : ''),
          locales: locales,
          onLanguage: selectLanguage,
          selected: selectedLocale })
      );
    }
  }]);

  return _class2;
}(React.Component /*:: <LangSelectProps, LangSelectState> */))(_templateObject3);
LangSelect.displayName = 'LangSelect';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/LangSelect.js
// module id = 236
// module chunks = 0